import { Form, Button, Select, Typography } from "antd";
import FormItem from "antd/lib/form/FormItem";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { setCurrentSubscriptionId, getAccessToken } from "services/auth";
import { AppLogoIcon } from "components/svg-icons";
import jwtDecode from "jwt-decode";
import PiiConsent from "components/widgets/pii-consent";

const { Title } = Typography;

function SubscriptionSelect() {
  const history = useHistory();
  const location = useLocation();
  const redirectUrl = new URLSearchParams(location.search).get("redirectUrl");

  const [subscriptionForm] = Form.useForm();
  const [userSubscriptions, setUserSubscriptions] = useState<any[]>([]);

  useEffect(() => {
    const token = getAccessToken();
    if (!token) {
      history.push("/");
      return;
    }

    try {
      const decodedToken: any = jwtDecode(token);
      const subscriptions = decodedToken?.associated_subscriptions || [];

      if (subscriptions.length === 0) {
        history.push("/");
        return;
      }

      if (subscriptions.length === 1) {
        setCurrentSubscriptionId(subscriptions[0].id);
        if (redirectUrl) history.push(redirectUrl);
        else history.push("/projects");
        return;
      }

      const subArr = subscriptions.sort((subA: any, subB: any) =>
        subA?.name?.toLowerCase() > subB?.name?.toLowerCase() ? 1 : -1
      );
      setUserSubscriptions(subArr);
      subscriptionForm.setFieldsValue({
        subscriptionId: subscriptions[0].id
      });
    } catch (error) {
      console.error("Error decoding token:", error);
      history.push("/");
    }
  }, [history, subscriptionForm, redirectUrl]);

  const onSubscriptionFinish = (subscriptionData: any) => {
    setCurrentSubscriptionId(subscriptionData.subscriptionId);
    if (redirectUrl) history.push(redirectUrl);
    else history.push("/projects");
  };

  return (
    <div className="login">
      <div className="login-form">
        <div style={{ margin: "auto", display: "block" }}>
          <AppLogoIcon />
        </div>
        <div className="login-logo" style={{ paddingBottom: "50px" }}>
          <Title level={3} className="mt-3">
            Login
          </Title>
        </div>
        <div className="px-1">
          <Form
            onFinish={onSubscriptionFinish}
            form={subscriptionForm}
            labelCol={{ span: 50 }}
            wrapperCol={{ span: 30 }}
            scrollToFirstError
            layout="vertical"
            className="-mt-10"
          >
            <FormItem name="subscriptionId" label="Choose a subscription">
              <Select
                showSearch
                optionFilterProp="label"
                className="w-full"
                onChange={() => {}}
                options={userSubscriptions.map((sub: any) => {
                  return {
                    value: sub.id,
                    label: sub.name
                  };
                })}
              />
            </FormItem>

            <div
              style={{ paddingTop: "1em" }}
              className="w-full grid grid-cols-3 content-center"
            >
              <div className="flex items-center" />
              <div className="flex justify-center w-full pb-3">
                <Button htmlType="submit" size="middle" className="w-full">
                  Continue
                </Button>
              </div>
              <div />
            </div>
          </Form>
        </div>
      </div>
      <PiiConsent className="w-[350px] text-center text-xs text-[#949492] pt-7" />
    </div>
  );
}

export default SubscriptionSelect;
